export default __webpack_public_path__ + "static/media/484.550db49d.png";